import { useQuery, useMutation } from '@tanstack/react-query';

import Axios from 'axios';

import { forceReloadProject } from '@hooks/API/Project/UseProject';

const getProjectPrevisionalTransactions = (projectId) =>
    Axios.get(`/PrevisionalTransactions/GetForProject/${projectId}`);

const usePrevisionalTransactions = (projectId) => {
    return useQuery({
        queryKey: ['previsionalTransactions', projectId],
        queryFn: () => getProjectPrevisionalTransactions(projectId),
        staleTime: 60000,
        cacheTime: 60000,
        retry: false,
    });
};

const onDeletePrevisionalTransaction = ({ ID }) => Axios.delete(`/PrevisionalTransactions/${ID}`);

const useDeletePrevisionalTransaction = () => {
    return useMutation({
        mutationFn: onDeletePrevisionalTransaction,
        onSuccess: (data, variables) => {
            forceReloadProject(variables.projectId);
        },
    });
};

const onUpdatePrevisionalTransaction = ({ transactionData }) => Axios.put('/PrevisionalTransactions', transactionData);

const useUpdatePrevisionalTransaction = () => {
    return useMutation({
        mutationFn: onUpdatePrevisionalTransaction,
        onSuccess: (data, variables) => {
            forceReloadProject(variables.transactionData.ProjectID);
        },
    });
};

const onAddPrevisionalTransaction = ({ transactionData }) => Axios.post('/PrevisionalTransactions', transactionData);

const useAddPrevisionalTransaction = () => {
    return useMutation({
        mutationFn: onAddPrevisionalTransaction,
        onSuccess: (data, variables) => {
            forceReloadProject(variables.transactionData.ProjectID);
        },
    });
};

export {
    usePrevisionalTransactions,
    useDeletePrevisionalTransaction,
    useUpdatePrevisionalTransaction,
    useAddPrevisionalTransaction,
};
